import type { CellContext } from '@/components/ui/table/types'
import { formatDate, humanizeDate } from '@/utils'

export const DateCell = (cell: CellContext<any, string>) =>
  formatDate(cell.getValue())

export const HumanizedDateCell = (cell: CellContext<any, string>) =>
  humanizeDate(cell.getValue())
